export enum ArrowKeyCodes {
    LEFT = 37,
    UP = 38,
    RIGHT = 39,
    DOWN = 40
}
